import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useFunnelStore = defineStore(
  'funnel',
  () => {
    const activeSave = ref(false);
    const activePublish = ref(false);
    const funnelData = ref<any>({})
    const allowSave = ref(false)
    const allowPublish = ref(false)
    const updateSaveState = (val: boolean) => {
      activeSave.value = val
    }
    const updatePublishState = (val: boolean) => {
      activePublish.value = val;
    };

    const updateFunnelData = (val: any) => {
      funnelData.value = val
    }

    const updateAllowSave = (val: boolean) => {
      allowSave.value = val
    }

    const updateAllowPublish = (val: boolean) => {
      allowPublish.value = val
    }

    return {
      activeSave,
      activePublish,
      funnelData,
      allowSave,
      allowPublish,
      updateSaveState,
      updatePublishState,
      updateFunnelData,
      updateAllowSave,
      updateAllowPublish,
    };
  },
  {
    persist: true,
  }
)
